import { Column, Row } from 'src/components-v2/Layout';
import styled from 'threads5/themes/styled';

const ButtonLink = styled('a')(({ theme }) => {
  return {
    display: 'inline-flex',
    padding: '8px 32px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '46px',
    color: '#FFF',
    '&:hover, &:focus': {
      color: '#FFF',
    },
    transition: 'background 0.3s ease',

    textAlign: 'center',
    fontFamily: theme.typography.sans,
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%' /* 30px */,
  };
});

const TableFooter = () => {
  return (
    <Row
      lgOffset={2}
      lg={20}
      sx={{
        padding: { sm: '20px 25px' },
      }}
    >
      <Column
        xs={0}
        smOffset={6}
        sm={6}
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
          },
          justifyContent: 'center',
        }}
      >
        <ButtonLink
          sx={{
            background: 'linear-gradient(93deg, #00819A 50%, #10D1B7 100%)',
            backgroundSize: '200% 100%',
            backgroundPosition: '100% 0',
            '&:hover, &:focus': {
              backgroundPosition: '70% 0',
            },
          }}
          href='https://dashboard.plaid.com/signup'
        >
          Request access
        </ButtonLink>
      </Column>
      <Column
        xs={0}
        sm={6}
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
          },
          justifyContent: 'center',
        }}
      >
        <ButtonLink
          sx={{
            background: 'linear-gradient(91deg, #3F2977 50%, #D45AED 100%)',
            backgroundSize: '200% 100%',
            backgroundPosition: '100% 0',
            '&:hover, &:focus': {
              backgroundPosition: '70% 0',
            },
          }}
          href='https://plaid.com/contact/'
        >
          Talk with our team
        </ButtonLink>
      </Column>
      <Column
        xs={0}
        sm={6}
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
          },
          justifyContent: 'center',
        }}
      >
        <ButtonLink
          sx={{
            background: 'linear-gradient(93deg, #633ECB 50%, #0DADF2 100%)',
            backgroundSize: '200% 100%',
            backgroundPosition: '100% 0',
            '&:hover, &:focus': {
              backgroundPosition: '70% 0',
            },
          }}
          href='https://plaid.com/contact/'
        >
          Talk with our team
        </ButtonLink>
      </Column>
    </Row>
  );
};

export default TableFooter;
